(function () {
  'use strict';

  var RS = window.RS || {};

  /* ---------------- Mobile nav ---------------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
  }

  /* ---------------- Money formatting (fallback if Shopify JS not loaded) ---------------- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var symbol = (RS.currency === 'USD') ? '$' : '€';
    return RS.currency === 'USD' ? symbol + amount : amount + ' ' + symbol;
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.getElementById('cart-drawer');
  var itemsWrap = drawer ? drawer.querySelector('[data-cart-items]') : null;
  var emptyMsg = drawer ? drawer.querySelector('[data-cart-empty]') : null;
  var footEl = drawer ? drawer.querySelector('[data-cart-foot]') : null;
  var totalEl = drawer ? drawer.querySelector('[data-cart-total]') : null;
  var countEls = document.querySelectorAll('[data-cart-count]');
  var upsellEl = drawer ? drawer.querySelector('[data-cart-upsell]') : null;
  var lastFocused = null;

  function openDrawer() {
    if (!drawer) { window.location.href = RS.routes.cart; return; }
    lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = drawer.querySelector('.drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (RS.cartType === 'drawer') {
        e.preventDefault();
        renderCart();
        openDrawer();
      }
    });
  });

  function lineRowHTML(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_120x120$1$2') + '" alt="' + escapeHTML(item.product_title) + '" loading="lazy">' : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="dline__var">' + escapeHTML(item.variant_title) + '</p>' : '';
    return (
      '<div class="dline" data-line-key="' + item.key + '">' +
        img +
        '<div class="dline__body">' +
          '<p class="dline__title">' + escapeHTML(item.product_title) + '</p>' +
          variant +
          '<div class="dline__row">' +
            '<span class="qty">' +
              '<button type="button" data-qty-down aria-label="Restar una unidad">' + '\u2212' + '</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-up aria-label="Añadir una unidad">+</button>' +
            '</span>' +
            '<span class="dline__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="dline__remove" data-line-remove>Quitar</button>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderCart() {
    if (!drawer) return;
    fetch(RS.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCart(cart); })
      .catch(function () {});
  }

  function paintCart(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (!itemsWrap) return;

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '';
      if (emptyMsg) emptyMsg.hidden = false;
      if (footEl) footEl.hidden = true;
      if (upsellEl) upsellEl.hidden = true;
      return;
    }

    if (emptyMsg) emptyMsg.hidden = true;
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    itemsWrap.innerHTML = cart.items.map(lineRowHTML).join('');

    if (upsellEl) {
      var upsellProductId = parseInt(upsellEl.getAttribute('data-product-id'), 10);
      var alreadyInCart = cart.items.some(function (it) { return it.product_id === upsellProductId; });
      upsellEl.hidden = alreadyInCart;
    }
  }

  function changeLine(key, quantity) {
    return fetch(RS.routes.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(paintCart);
  }

  function addItem(variantId, quantity) {
    return fetch(RS.routes.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return fetch(RS.routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (cart) {
      paintCart(cart);
      if (RS.cartType === 'drawer') openDrawer();
      else window.location.href = RS.routes.cart;
    }).catch(function (err) {
      console.error('No se pudo añadir el producto', err);
      window.location.href = RS.routes.cart;
    });
  }

  if (itemsWrap) {
    itemsWrap.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line-key]');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var qtyEl = row.querySelector('.qty span');
      var qty = parseInt(qtyEl.textContent, 10);

      if (e.target.closest('[data-qty-up]')) changeLine(key, qty + 1);
      else if (e.target.closest('[data-qty-down]')) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
    });
  }

  if (upsellEl) {
    upsellEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-upsell-add]')) {
        addItem(upsellEl.getAttribute('data-variant-id'), 1);
      }
    });
  }

  /* Simple "add to cart" buttons on product cards / bundle (single-variant products) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    addItem(btn.getAttribute('data-add-variant'), 1).finally(function () {
      btn.disabled = false;
      btn.textContent = original;
    });
  });

  /* Product form (variant selector) submits normally via /cart/add, then we open the drawer via redirect param is overkill;
     for simplicity we let native form post but intercept when JS is available for a smoother drawer experience. */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      if (RS.cartType !== 'drawer') return; // let it navigate to cart page normally
      e.preventDefault();
      var submitBtn = productForm.querySelector('[data-product-submit]');
      var variantInput = productForm.querySelector('[data-product-variant-id]');
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;
      var original = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Añadiendo…';
      addItem(variantId, 1).finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = original;
      });
    });
  }

  /* Product thumbnail swap */
  document.querySelectorAll('.product__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = btn.querySelector('img');
      var main = document.getElementById('ProductMedia');
      if (img && main) main.src = img.src;
    });
  });

  /* ---------------- Margin calculator (hero price tag) ---------------- */
  var calcForm = document.querySelector('[data-calc]');
  if (calcForm) {
    var inputs = {
      buy: calcForm.querySelector('[data-calc-in="buy"]'),
      sell: calcForm.querySelector('[data-calc-in="sell"]'),
      fee: calcForm.querySelector('[data-calc-in="fee"]'),
      ship: calcForm.querySelector('[data-calc-in="ship"]')
    };
    var outputs = {
      profit: calcForm.querySelector('[data-calc-out="profit"]'),
      margin: calcForm.querySelector('[data-calc-out="margin"]'),
      roi: calcForm.querySelector('[data-calc-out="roi"]')
    };

    function num(el) {
      var v = parseFloat((el.value || '0').replace(',', '.'));
      return isNaN(v) ? 0 : v;
    }

    function currencySymbol() {
      return (RS.currency === 'USD') ? '$' : '€';
    }

    function calc() {
      var buy = num(inputs.buy);
      var sell = num(inputs.sell);
      var feePct = num(inputs.fee);
      var ship = num(inputs.ship);

      var fee = sell * (feePct / 100);
      var profit = sell - buy - fee - ship;
      var margin = sell > 0 ? (profit / sell) * 100 : 0;
      var roi = buy > 0 ? (profit / buy) * 100 : 0;
      var sym = currencySymbol();

      outputs.profit.textContent = profit.toFixed(2).replace('.', ',') + ' ' + sym;
      outputs.profit.style.color = profit < 0 ? '#c0392b' : '';
      outputs.margin.textContent = margin.toFixed(0) + '%';
      outputs.roi.textContent = roi.toFixed(0) + '%';
    }

    Object.keys(inputs).forEach(function (key) {
      inputs[key].addEventListener('input', calc);
    });
    calcForm.addEventListener('submit', function (e) { e.preventDefault(); });
    calc();
  }

  /* Initial cart paint on load, so the badge is correct without a full render call */
  if (drawer) renderCart();
})();
